module.exports = __webpack_public_path__ + "static/dacosta-fc26ec2a0798fbccce1720148501c742.png";